import React, { useEffect, useState } from 'react';
import ContractReportTemplate from '../../_components/templates/ContractReportTemplate';
import TabSelection from '../../_components/molecules/TabSelection';
import { Divider, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  BasicAccordion,
  BasicTable,
  CardComponent,
  Chip,
  GeneralCardComponent,
  RegulationsCard,
  RegulationsStatusCard,
  Tooltip,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import {
  TextWithIcon,
  Typography,
} from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { useLocation, useNavigate } from 'react-router-dom';
import GifWithLabels from '@HomaHealth/ui-component-library/lib/_patient-access-components/molecules/GIFWithLabels';
import Contract from '../../../public/Images/Contract.png';
import contractAIQConstants from '../../core-utils/messages/ContractAIQConstants';
import ClauseInfo from '../../_components/organisms/ClauseInfo';
import properties from '../../core-utils/properties';
import axios from 'axios';
import {
  TitleAndSubTitle,
  getReportBreadcrumbList,
} from '../../core-utils/helper-utils/contractAIQHelper';
import SvgInfo from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/Icons/Info';
import Loader from '../../_components/molecules/Loader';
import componentConstants from '../../core-utils/messages/componentConstants';
import { base64toByteArrayConverter } from '../../core-utils/helper-utils/downloadPdfHelper';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import Snackbar from '../../_components/atoms/Snackbar';
import { useStores } from '../../stores';

const GagClauseReport = () => {
  //styles
  const useStyles = makeStyles()({
    tabContent: {
      paddingTop: '24px',
    },
    accordionContent: {
      borderTop: `1px solid ${patientAccessTheme.palette.grey[300]}`,
      width: '100%',
      paddingTop: '24px',
    },
    divider: {
      margin: '32px 0px',
    },
    gagClauseLabelGrid: {
      paddingBottom: '12px',
      borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    },
    unorderedList: {
      margin: 0,
      paddingLeft: '19px',
    },
    aboutAndDescription: {
      display: 'flex',
      gap: '32px',
      margin: '28px 0px 24px 0px',
    },
  });

  //constants
  const { classes } = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const employerGroupStore = useStores().employerGroupStore;
  const {
    reportName,
    document,
    contractId,
    draftId,
    isDraft,
  }: any = location.state;
  const breadcrumbs = getReportBreadcrumbList(
    navigate,
    location?.state,
    isDraft,
  );
  const constants = contractAIQConstants.CONTRACT_REPORTS.GAG_CLAUSE_REPORT;
  const keyDatesAndResponsibilities: { key: string; value: string }[] = [
    {
      key: 'First attestation due',
      value: 'Dec 31, 2023',
    },
    {
      key: 'Attestation Period',
      value: ' Dec 27, 2020 - Dec 31, 2023',
    },
    {
      key: 'Attestation Liability',
      value:
        ' Remains with the Plan. If a self-insured plan chooses to enter into an agreement with the plan’s service provider to file the attestation on their behalf, the legal requirement to provide a timely attestation remains with the plan.',
    },
    {
      key: 'Penalties',
      value:
        ' The DOL can impose on the Plan a fine of $100 per employee per day of noncompliance',
    },
  ];

  const cellStyles = {
    color: patientAccessTheme.palette.text.highemphasis,
    fontSize: '12px',
    fontWeight: 500,
  };
  const columnsForCheckOffList: any[] = [
    {
      name: 'Questions',
      align: 'left',
      cellStyles: cellStyles,
      // width: '500px',
    },
    {
      name: 'Compliance',
      align: 'center',
      cellStyles: cellStyles,
      // width: '200px',
    },
  ];

  //states
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);
  const [activeTab, setActiveTab] = useState<{ id: string; index?: number }>({
    id: 'summary',
    index: 0,
  });
  const [gagClauses, SetGagClauses] = useState<any>([]);
  const [selectedClause, setSelectedClause] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(true);
  const [loader] = useState<any>(<Loader />);
  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });

  //APIs
  const getGagClauseReportData = () => {
    const url =
      properties.aiqBaseUrl +
      properties.contractBaseUrl +
      properties.gagClauseReport;
    axios
      .post(url, {
        ...(isDraft ? { draft_id: draftId } : { contract_id: contractId }),
      })
      .then((response) => {
        const data = response?.data?.data;
        SetGagClauses(data?.gagClauses);
        setLoading(false);
      })
      .catch((error) => {
        throw error;
      });
  };

  //functions
  const handleCloseSnackBar = () => {
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const handleReportSummary = () => {
    setActiveTab({ id: 'summary', index: 0 });
  };

  const handleDownloadReport = () => {
    const token = JSON.parse(localStorage.getItem('token-storage') as string)
      ?.access_token;
    const messages =
      componentConstants.ORGANISMS.REPORTS_MODAL.SNACKBAR_MESSAGES;
    handleOpenSnackBar(messages.DOWNLOAD_REPORT, 'info', 5000);
    axios
      .post(
        properties.aiqBaseUrl + properties.downloadComplianceAssuranceReport,
        {
          ...(isDraft ? { draft_id: draftId } : { contract_id: contractId }),
          employer:
            employerGroupStore?.employerGroupResponseData
              ?.employer_group_name[0],
          reportName: 'gagClauseReport',
        },
        {
          headers: {
            Authorization: token,
          },
        },
      )
      .then((res) => {
        if (res) {
          const byteArray = base64toByteArrayConverter(res.data?.data);
          const file = new Blob([byteArray], {
            type: 'application/pdf;base64',
          });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL, '_blank');
          handleOpenSnackBar(messages.OPEN_SUCCESS, 'success', 5000);
        }
      })
      .catch((error) => {
        handleOpenSnackBar(
          error.response?.data?.error ?? messages.API_ERROR,
          'error',
          5000,
        );
      });
  };

  //function to get content of report summary tabs based on tab index
  const getTabContent = () => {
    switch (selectedTabIndex) {
      case 0:
        return <GagClausesSummary />;
      default:
        return <></>;
    }
  };

  //function to get content on the right based on left tab selection
  const getActiveTabContent = () => {
    switch (activeTab.id) {
      case 'summary':
        return <ReportSummaryContent />;
      case 'clauses-present':
        return <GagClausesPresent />;
      case 'no-clauses':
        return <GagClausesNotPresent />;
      default:
        return <></>;
    }
  };

  //useEffects
  useEffect(() => {
    getGagClauseReportData();
  }, []);

  //components
  //component for list of Clauses on the left
  const GagClauses = () => {
    return (
      <Grid>
        {gagClauses?.map((item: any, index: number) => {
          const totalCount = item?.metList?.length + item?.notMetList?.length;
          const metCount = item?.metList?.length;
          const notmetCount = item?.notMetList?.length;

          const type = metCount === totalCount ? 'Met' : 'Not Met';
          const description = `${
            type === 'Not Met' ? notmetCount : 'No'
          } Gag Clause${notmetCount === 1 ? '' : 's'} present`;

          return (
            <RegulationsCard
              type={type}
              title={item?.name}
              description={description}
              count={type === 'Not Met' ? notmetCount : ''}
              tooltip={item?.aim}
              handleOnclick={() => {
                setActiveTab({
                  id: type === 'Met' ? 'no-clauses' : 'clauses-present',
                  index: index + 1,
                });
                setSelectedClause(item);
              }}
              isActive={activeTab.index === index + 1}
            />
          );
        })}
      </Grid>
    );
  };

  //component for report summary content
  const ReportSummaryContent = () => {
    return (
      <>
        <TabSelection
          selectedTabIndex={selectedTabIndex}
          setSelectedTabIndex={setSelectedTabIndex}
          tabList={constants.SUMMARY_TABS}
        />
        <Grid className={classes.tabContent}>{getTabContent()}</Grid>
      </>
    );
  };

  //components for repetitive Typography
  const getContentTypography = (label: string) => {
    return (
      <Typography
        fontSize="14px"
        lineHeight="24px"
        fontType="regular"
        textColor={patientAccessTheme.palette.text.highemphasis}
      >
        {label}
      </Typography>
    );
  };

  const getSubtitleTypography = (label: string, bold?: boolean) => {
    return (
      <Typography
        fontSize="14px"
        fontType={bold ? 'semiBold' : 'regular'}
        lineHeight="24px"
        textColor={patientAccessTheme.palette.text.mediumemphasis}
        display="inline"
      >
        {label}
      </Typography>
    );
  };

  //component for gag clause tab content
  const GagClausesSummary = () => {
    const replaceRestriction = (text: string) => {
      switch (true) {
        case text?.includes('Restriction of Access to Data'):
          return 'access to data';
        case text?.includes('Restriction of Usage of Data'):
          return 'usage of data';
        case text?.includes('Restriction of Audit of Data'):
          return 'auditing of data';
        default:
          return text;
      }
    };
    let totalNotMet = 0;
    const categoriesWithGags: any[] = [];
    gagClauses?.map((item: any) => {
      if (item?.notMetList?.length > 0) {
        categoriesWithGags.push({
          category: item?.name,
          count: item?.notMetList?.length,
        });
      }
      totalNotMet += item?.notMetList?.length;
    });

    const totalCategoriesWithGags = categoriesWithGags?.length;

    return (
      <Grid>
        <Typography
          fontSize="16px"
          fontType="semiBold"
          lineHeight="140%"
          textColor={patientAccessTheme.palette.text.highemphasis}
          margin="0px 0px 12px 0px"
        >
          {constants.SUMMARY.TITLE}
        </Typography>
        <Grid>
          {totalNotMet === 0 ? (
            <>
              {getSubtitleTypography(constants.SUMMARY.SUBTITLE.PART1)}
              {getSubtitleTypography('no gag clauses.', true)}
            </>
          ) : (
            // <>
            //   {getSubtitleTypography(constants.SUMMARY.SUBTITLE.PART1)}
            //   {getSubtitleTypography(`${totalNotMet} gag clauses`, true)}
            //   {getSubtitleTypography(constants.SUMMARY.SUBTITLE.PART2)}
            //   {categories?.map((item: any, index: number) => (
            //     <>
            //       {getSubtitleTypography(
            //         `${item?.category} (${item?.count} clause${
            //           item?.count > 1 ? 's' : ''
            //         })${
            //           index === categories?.length - 1
            //             ? '.'
            //             : index === categories?.length - 2
            //             ? ' '
            //             : ', '
            //         }`,
            //         true,
            //       )}
            //       {index === categoriesWithGags?.length - 2 &&
            //         getSubtitleTypography(' and ')}
            //     </>
            //   ))}
            // </>
            <>
              {getSubtitleTypography(
                `The analysis of the contract reveals significant restrictions in ${totalCategoriesWithGags} key area${
                  totalCategoriesWithGags > 1 ? 's' : ''
                }: ${categoriesWithGags?.map(
                  (item, index) =>
                    `${
                      index + 1 === totalCategoriesWithGags ? ' and' : ''
                    } ${replaceRestriction(item?.category)}`,
                )}. `,
              )}
              {getSubtitleTypography(
                `Specifically, the contract imposes ${
                  categoriesWithGags?.find((item) =>
                    item?.category?.includes('Restriction of Access to Data'),
                  )?.count || 'no'
                } restrictions related to the access of provider-specific quality of care, cost data, and deidentified claims data.`,
              )}
              {getSubtitleTypography(
                ` In terms of data usage, there are ${
                  categoriesWithGags?.find((item) =>
                    item?.category?.includes('Restriction of Usage of Data'),
                  )?.count || 'no'
                }  restrictions on how provider-specific cost and quality of care data and deidentified claims data can be utilized, particularly for benchmarking, transparency tools, and reporting. `,
              )}
              {getSubtitleTypography(
                `Additionally, the contract includes ${
                  categoriesWithGags?.find((item) =>
                    item?.category?.includes('Restriction of Audit of Data'),
                  )?.count || 'no'
                } restrictions on auditing processes.`,
              )}
            </>
          )}
        </Grid>
        <Grid className={classes.aboutAndDescription}>
          <GeneralCardComponent
            title={constants.ABOUT.TITLE}
            body={getContentTypography(constants.ABOUT.DESCRIPTION)}
            headerStyles={{ padding: '16px' }}
            bodyStyles={{ padding: '16px' }}
            width="436px"
          />
          <GeneralCardComponent
            title={constants.PURPOSE.TITLE}
            body={
              <ul className={classes.unorderedList}>
                {constants.PURPOSE.DESCRIPTION?.map((label: string) => (
                  <li>{getContentTypography(label)}</li>
                ))}
              </ul>
            }
            width="436px"
            headerStyles={{ padding: '16px' }}
            bodyStyles={{ padding: '16px' }}
          />
        </Grid>
        <Grid style={{ marginBottom: '42px' }}>
          <GeneralCardComponent
            title={constants.KEY_DATES_AND_RESPONSIBILITIES.TITLE}
            body={
              <ul className={classes.unorderedList}>
                {keyDatesAndResponsibilities?.map((item: any) => (
                  <li>
                    <Typography
                      fontSize="14px"
                      fontType="medium"
                      lineHeight="24px"
                      textColor={patientAccessTheme.palette.text.highemphasis}
                      display="inline"
                    >
                      {`${item.key}: `}
                    </Typography>
                    <Typography
                      fontSize="14px"
                      fontType="regular"
                      lineHeight="24px"
                      textColor={patientAccessTheme.palette.text.highemphasis}
                      display="inline"
                    >
                      {item.value}
                    </Typography>
                  </li>
                ))}
              </ul>
            }
            width="436px"
            headerStyles={{ padding: '16px' }}
            bodyStyles={{ padding: '16px' }}
          />
        </Grid>
        <Grid className={classes.gagClauseLabelGrid}>
          <Typography
            fontSize="18px"
            fontType="semiBold"
            lineHeight="21.78px"
            textColor={patientAccessTheme.palette.text.highemphasis}
            margin="0px 0px 7px 0px"
          >
            {constants.GAG_CLAUSES}
          </Typography>
        </Grid>
        <Grid>
          {gagClauses?.map((clause: any) => (
            <Grid>
              <Grid style={{ margin: '24px 0px 16px 0px' }}>
                <TextWithIcon
                  label={
                    <Typography
                      fontSize="14px"
                      fontType="semiBold"
                      lineHeight="24px"
                      textColor={patientAccessTheme.palette.text.highemphasis}
                    >
                      {clause?.name}
                    </Typography>
                  }
                  endIcon={
                    clause?.aim && (
                      <Tooltip title={clause?.aim}>
                        <div style={{ cursor: 'pointer', display: 'flex' }}>
                          <SvgInfo />
                        </div>
                      </Tooltip>
                    )
                  }
                  endIconLeftMargin="8px"
                />
              </Grid>
              {ListOfClauseCategories(clause)}
            </Grid>
          ))}
        </Grid>
      </Grid>
    );
  };

  //component for list of categories for a clause
  const ListOfClauseCategories = (clause: any) => {
    return (
      <Grid>
        {clause?.notMetList?.length > 0 && (
          <>
            {clause?.notMetList?.map((item: any) => (
              <Grid style={{ marginBottom: '12px' }}>
                <ClauseInfo
                  type={'Not Met'}
                  chipLabel="Present"
                  title={item?.question}
                  summaryTitle={
                    item?.reason?.length > 0 ? 'Analysis of Clause' : undefined
                  }
                  summaryDescription={item?.reason[0]}
                  reasonsTitle={
                    item?.exact_text?.length > 0
                      ? 'Extract from Agreement'
                      : undefined
                  }
                  reasons={item?.exact_text}
                />
              </Grid>
            ))}
          </>
        )}
        {clause?.metList?.length > 0 && (
          <>
            {clause?.metList?.map((item: any) => (
              <Grid style={{ marginBottom: '12px' }}>
                <ClauseInfo
                  type={'Met'}
                  chipLabel="Absent"
                  title={item?.question}
                  summaryTitle={
                    item?.reason?.length > 0 ? 'Analysis of Clause' : undefined
                  }
                  summaryDescription={item?.reason[0]}
                  reasonsTitle={
                    item?.exact_text?.length > 0
                      ? 'Extract from Agreement'
                      : undefined
                  }
                  reasons={item?.exact_text}
                  content={
                    !(item?.reason?.length || item?.exact_text?.length) && (
                      <GifWithLabels
                        mainLabel={constants.NO_CLAUSES.TITLE}
                        subLabel={''}
                        gifUrl={Contract}
                        gifWidth="150px"
                        gifHeight="150px"
                      />
                    )
                  }
                />
              </Grid>
            ))}
          </>
        )}
      </Grid>
    );
  };

  //component for gag clauses present
  const GagClausesPresent = () => {
    return (
      <>
        {TitleAndSubTitle(selectedClause?.name, selectedClause?.aim)}
        <Divider className={classes.divider} />
        <RegulationsStatusCard
          type={'Not Met'}
          title={constants.GAG_CLAUSES}
          count={selectedClause?.notMetList?.length}
        />
        <Divider className={classes.divider} />
        <Typography
          fontSize="14px"
          fontType="medium"
          lineHeight="22.4px"
          textColor={patientAccessTheme.palette.text.highemphasis}
          margin="0px 0px 24px 0px"
        >
          {constants.GAG_CLAUSES}
        </Typography>
        {ListOfClauseCategories(selectedClause)}
      </>
    );
  };

  //component for no gag clauses present
  const GagClausesNotPresent = () => {
    const tableData: any[] = [];
    selectedClause?.metList?.map((item: any) => {
      const eachRow: any[] = [];
      eachRow[0] = item?.question;
      eachRow[1] = (
        <Chip
          label={
            <Typography
              fontSize="12px"
              lineHeight="15px"
              fontType="medium"
              textColor={patientAccessTheme.palette.AIQChips?.textColor2}
            >
              {'Absent'}
            </Typography>
          }
          backgroundColor={patientAccessTheme.palette.AIQChips?.background2}
          border="0.3px solid rgba(0, 130, 114, 0.5)"
          borderRadius="4px"
          height="25px"
        />
      );
      tableData.push(eachRow);
    });

    return (
      <>
        {TitleAndSubTitle(selectedClause?.name, selectedClause?.aim)}
        <Divider className={classes.divider} />
        <Grid style={{ marginBottom: '32px' }}>
          <BasicAccordion
            title={constants.CHECK_OFF_LIST}
            expandDefault
            content={
              <Grid className={classes.accordionContent}>
                <BasicTable
                  displayType="row"
                  columns={columnsForCheckOffList}
                  rowsData={tableData}
                  isFullTable
                />
              </Grid>
            }
          />
        </Grid>
        <CardComponent
          title={''}
          body={
            <GifWithLabels
              mainLabel={constants.NO_CLAUSES.TITLE}
              subLabel={''}
              gifUrl={Contract}
              gifWidth="150px"
              gifHeight="150px"
            />
          }
        />
      </>
    );
  };

  return (
    <>
      {loading ? (
        loader
      ) : (
        <ContractReportTemplate
          breadcrumbsList={breadcrumbs}
          reportName={`${reportName} of`}
          document={document}
          handleDocumentOnclick={() => {}}
          handleDownloadReport={handleDownloadReport}
          handleReportSummary={handleReportSummary}
          isReportSummaryActive={activeTab.id === 'summary'}
          leftContent={<GagClauses />}
          rightContent={getActiveTabContent()}
          showDownloadReport={true}
        />
      )}
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
    </>
  );
};

export default GagClauseReport;
